import * as React from "react";

const EditBlueIcon = (props) => (
  <svg
    width={14}
    height={13}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0779 1.46793C10.2368 1.31958 10.4255 1.2019 10.6332 1.12161C10.8409 1.04132 11.0635 1 11.2883 1C11.513 1 11.7356 1.04132 11.9433 1.12161C12.151 1.2019 12.3397 1.31958 12.4986 1.46793C12.6576 1.61629 12.7837 1.79241 12.8697 1.98624C12.9557 2.18007 13 2.38782 13 2.59762C13 2.80743 12.9557 3.01518 12.8697 3.20901C12.7837 3.40284 12.6576 3.57896 12.4986 3.72732L4.32855 11.3527L1 12.2L1.90779 9.09335L10.0779 1.46793Z"
      stroke="#8b58f1"
      strokeWidth={1.32}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditBlueIcon;
